/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Donor_Todonatekey2Inputs */

const id_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untuk menyumbangkan kunci.`)
};

const ms_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untuk menderma kunci.`)
};

const da_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for at donere en nøgle.`)
};

const de_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`um einen Schlüssel zu spenden.`)
};

const en_us2_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to donate a key.`)
};

const es_es2_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para donar una clave.`)
};

const es_mx2_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para donar una llave.`)
};

const fil_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`upang mag-donate ng key.`)
};

const fr_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pour faire don d'une clé.`)
};

const it_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per donare una chiave.`)
};

const hu_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egy kulcs adományozásához.`)
};

const nl_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`om een sleutel te doneren.`)
};

const no_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for å donere en nøkkel.`)
};

const pl_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aby przekazać klucz.`)
};

const pt_br2_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para doar uma chave.`)
};

const pt_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para doar uma chave.`)
};

const ro_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pentru a dona o cheie.`)
};

const fi_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lahjoittaaksesi avaimen.`)
};

const sv_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`för att donera en nyckel.`)
};

const vi_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`để quyên góp key.`)
};

const tr_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anahtar bağışlamak için.`)
};

const cs_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro darování klíče.`)
};

const bg_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за да дарите ключ.`)
};

const ru_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`чтобы пожертвовать ключ.`)
};

const uk_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`щоб пожертвувати ключ.`)
};

const ar_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`للتبرع بمفتاح.`)
};

const hi_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी दान करने के लिए।`)
};

const th_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพื่อบริจาคคีย์`)
};

const ja_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーを寄付する。`)
};

const zh_cn2_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捐赠Key。`)
};

const zh_hant1_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捐贈Key。`)
};

const ko_profile_donor_todonatekey2 = /** @type {(inputs: Profile_Donor_Todonatekey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에서 키를 기부할 수 있습니다.`)
};

/**
* | output |
* | --- |
* | "to donate a key." |
*
* @param {Profile_Donor_Todonatekey2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_donor_todonatekey2 = /** @type {((inputs?: Profile_Donor_Todonatekey2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Donor_Todonatekey2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_donor_todonatekey2(inputs)
	if (locale === "ms") return ms_profile_donor_todonatekey2(inputs)
	if (locale === "da") return da_profile_donor_todonatekey2(inputs)
	if (locale === "de") return de_profile_donor_todonatekey2(inputs)
	if (locale === "en-US") return en_us2_profile_donor_todonatekey2(inputs)
	if (locale === "es-ES") return es_es2_profile_donor_todonatekey2(inputs)
	if (locale === "es-MX") return es_mx2_profile_donor_todonatekey2(inputs)
	if (locale === "fil") return fil_profile_donor_todonatekey2(inputs)
	if (locale === "fr") return fr_profile_donor_todonatekey2(inputs)
	if (locale === "it") return it_profile_donor_todonatekey2(inputs)
	if (locale === "hu") return hu_profile_donor_todonatekey2(inputs)
	if (locale === "nl") return nl_profile_donor_todonatekey2(inputs)
	if (locale === "no") return no_profile_donor_todonatekey2(inputs)
	if (locale === "pl") return pl_profile_donor_todonatekey2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_donor_todonatekey2(inputs)
	if (locale === "pt") return pt_profile_donor_todonatekey2(inputs)
	if (locale === "ro") return ro_profile_donor_todonatekey2(inputs)
	if (locale === "fi") return fi_profile_donor_todonatekey2(inputs)
	if (locale === "sv") return sv_profile_donor_todonatekey2(inputs)
	if (locale === "vi") return vi_profile_donor_todonatekey2(inputs)
	if (locale === "tr") return tr_profile_donor_todonatekey2(inputs)
	if (locale === "cs") return cs_profile_donor_todonatekey2(inputs)
	if (locale === "bg") return bg_profile_donor_todonatekey2(inputs)
	if (locale === "ru") return ru_profile_donor_todonatekey2(inputs)
	if (locale === "uk") return uk_profile_donor_todonatekey2(inputs)
	if (locale === "ar") return ar_profile_donor_todonatekey2(inputs)
	if (locale === "hi") return hi_profile_donor_todonatekey2(inputs)
	if (locale === "th") return th_profile_donor_todonatekey2(inputs)
	if (locale === "ja") return ja_profile_donor_todonatekey2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_donor_todonatekey2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_donor_todonatekey2(inputs)
	return ko_profile_donor_todonatekey2(inputs)
});
export { profile_donor_todonatekey2 as "profile.donor.toDonateKey" }